import script from "./SocialIcon.vue?vue&type=script&lang=js&setup=true"
export * from "./SocialIcon.vue?vue&type=script&lang=js&setup=true"

const __exports__ = script;

export default __exports__